/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RouteValidationData,
    RouteValidationDataFromJSON,
    RouteValidationDataFromJSONTyped,
    RouteValidationDataToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShoppingDiagnosticsRequestValidationData
 */
export interface ShoppingDiagnosticsRequestValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ShoppingDiagnosticsRequestValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ShoppingDiagnosticsRequestValidationData
     */
    channel?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ShoppingDiagnosticsRequestValidationData
     */
    agency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ShoppingDiagnosticsRequestValidationData
     */
    passengerAges?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ShoppingDiagnosticsRequestValidationData
     */
    salesJourney?: ValidationMessage;
    /**
     * 
     * @type {Array<RouteValidationData>}
     * @memberof ShoppingDiagnosticsRequestValidationData
     */
    readonly routes?: Array<RouteValidationData> | null;
}

export function ShoppingDiagnosticsRequestValidationDataFromJSON(json: any): ShoppingDiagnosticsRequestValidationData {
    return ShoppingDiagnosticsRequestValidationDataFromJSONTyped(json, false);
}

export function ShoppingDiagnosticsRequestValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoppingDiagnosticsRequestValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'channel': !exists(json, 'channel') ? undefined : ValidationMessageFromJSON(json['channel']),
        'agency': !exists(json, 'agency') ? undefined : ValidationMessageFromJSON(json['agency']),
        'passengerAges': !exists(json, 'passengerAges') ? undefined : ValidationMessageFromJSON(json['passengerAges']),
        'salesJourney': !exists(json, 'salesJourney') ? undefined : ValidationMessageFromJSON(json['salesJourney']),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(RouteValidationDataFromJSON)),
    };
}

export function ShoppingDiagnosticsRequestValidationDataToJSON(value?: ShoppingDiagnosticsRequestValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'channel': ValidationMessageToJSON(value.channel),
        'agency': ValidationMessageToJSON(value.agency),
        'passengerAges': ValidationMessageToJSON(value.passengerAges),
        'salesJourney': ValidationMessageToJSON(value.salesJourney),
    };
}


